import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.QuoteItemPriceAdjustSupplierView.';
  public static readonly multiplierLabel = `${Id.prefix}multiplierLabel`;
  public static readonly marginLabel = `${Id.prefix}marginLabel`;
  public static readonly isTaxableItem = `${Id.prefix}isTaxableItem`;
  public static readonly quantity = `${Id.prefix}quantity`;
  public static readonly supplier = `${Id.prefix}supplier`;
  public static readonly extendedListPrice = `${Id.prefix}extendedListPrice`;
  public static readonly extendedListPriceTooltip = `${Id.prefix}extendedListPriceTooltip`;
  public static readonly priceAdjustment = `${Id.prefix}priceAdjustment`;
  public static readonly priceAdjustmentReason = `${Id.prefix}priceAdjustmentReason`;
  public static readonly buyInItems = `${Id.prefix}buyInItems`;
  public static readonly costPrice = `${Id.prefix}costPrice`;
  public static readonly franchisee = `${Id.prefix}franchisee`;
  public static readonly removeSupplierPriceAdjustment = `${Id.prefix}removeSupplierPriceAdjustment`;
}

export class LangQuoteItemPriceAdjustSupplierView {
  private constructor() {}
  public static multiplierLabel(params: { value: string }): string {
    return interpolate(Id.multiplierLabel, params);
  }
  public static marginLabel(params: { calculationLabel: string; percent: string }): string {
    return interpolate(Id.marginLabel, params);
  }
  public static isTaxableItem(): string {
    return interpolate(Id.isTaxableItem);
  }
  public static removeSupplierPriceAdjustment(): string {
    return interpolate(Id.removeSupplierPriceAdjustment);
  }
  public static quantity(): string {
    return interpolate(Id.quantity);
  }
  public static supplier(): string {
    return interpolate(Id.supplier);
  }
  public static extendedListPrice(): string {
    return interpolate(Id.extendedListPrice);
  }
  public static extendedListPriceTooltip(): string {
    return interpolate(Id.extendedListPriceTooltip);
  }
  public static priceAdjustment(): string {
    return interpolate(Id.priceAdjustment);
  }
  public static priceAdjustmentReason(): string {
    return interpolate(Id.priceAdjustmentReason);
  }
  public static buyInItems(): string {
    return interpolate(Id.buyInItems);
  }
  public static costPrice(): string {
    return interpolate(Id.costPrice);
  }
  public static franchisee(): string {
    return interpolate(Id.franchisee);
  }
}

export class QuoteItemPriceAdjustSupplierViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.multiplierLabel, 'Multiplier ({{value}})', 'Label for multiplier with value');
    register.add(
      Id.marginLabel,
      '{{calculationLabel}} (default {{percent}}%)',
      'Label for margin or markup with default percent'
    );
    register.add(Id.isTaxableItem, 'Is Taxable Item', 'Label for taxable item switch');
    register.add(Id.quantity, 'Quantity', 'Label for quantity field');
    register.add(Id.supplier, "{{glossary 'supplier'}}", 'Glossary term for supplier');
    register.add(Id.extendedListPrice, 'Extended List Price', 'Label for extended list price');
    register.add(
      Id.extendedListPriceTooltip,
      'The Extended List Price is Quantity multiplied by Item List Price',
      'Tooltip for extended list price'
    );
    register.add(Id.priceAdjustment, 'Price Adjustment', 'Label for price adjustment');
    register.add(Id.priceAdjustmentReason, 'Adjustment Reason', 'Label for price adjustment reason');
    register.add(Id.buyInItems, 'Buy-In Items', 'Label for buy-in items');
    register.add(Id.costPrice, 'Cost Price', 'Label for cost price');
    register.add(Id.franchisee, "{{glossary 'franchisee'}}", 'Glossary term for franchisee');
    register.add(
      Id.removeSupplierPriceAdjustment,
      'Clear',
      'Button text to remove supplier price adjustment (one word only)'
    );
  }
}
